export default __webpack_public_path__ + "static/media/signin-persona-social-worker.3c8b5bb0.svg";